import request from '@/utils/request'

// 获取作业列表
export function getHomeworkList() {
  return request({
    url: '/homework/list',
    method: 'get'
  })
}

// 根据课程ID获取作业列表
export function getHomeworkListByCourseId(courseId) {
  return request({
    url: `/homework/course/${courseId}`,
    method: 'get'
  })
}

// 根据用户ID和课程ID获取作业列表（支持教师和学生角色）
export function getHomeworkListByUserIdAndCourseId(userId, courseId) {
  return request({
    url: `/homework/user/${userId}/course/${courseId}`,
    method: 'get'
  })
}

// 创建作业
export function createHomework(data) {
  return request({
    url: '/homework/create',
    method: 'post',
    data
  })
}

// 删除作业
export function deleteHomework(id) {
  return request({
    url: `/homework/${id}`,
    method: 'delete'
  })
}

// 获取知识点内容
export function getKnowledgeContent(params) {
  return request({
    url: '/knowledge/getContent',
    method: 'get',
    params
  })
}

// 获取题目列表
export function getQuestionsByKnowledge(params) {
  return request({
    url: '/questions/byKnowledge',
    method: 'get',
    params
  })
}

// 获取前50道题目
export function getTop50Questions() {
  return request({
    url: '/questions/top50',
    method: 'get'
  })
}

// 获取特定作业的题目列表（学生开始作业）
export function getSpecificHomeworkQuestions(homeworkId) {
  return request({
    url: `/api/amc/homework/${homeworkId}/start`,
    method: 'post'
  })
}

// 根据作业ID获取关联的题目详细信息
export function getQuestionDetailsByHomeworkId(homeworkId) {
  return request({
    url: `/api/amc/homework/${homeworkId}`,
    method: 'get'
  })
}

// 保存特定作业的题目
export function saveSpecificHomework(homeworkId, data) {
  return request({
    url: `/specific-homework/save/${homeworkId}`,
    method: 'post',
    data
  })
}

// 获取班级列表
export function getClassList() {
  return request({
    url: '/grades/list',
    method: 'get'
  })
}

// 获取学生用户名
export function getStudentUsername(studentId) {
  return request({
    url: `/user/${studentId}/username`,
    method: 'get'
  })
}

// 获取批改结果
export function getCorrectionResult(homeworkId, studentId) {
  return request({
    url: `/correct-result/homework/${homeworkId}/student/${studentId}`,
    method: 'get'
  })
}

// 批量保存批改结果
export function saveCorrectionResults(data) {
  return request({
    url: '/correct-result/batch',
    method: 'put',
    data
  })
}

// 获取知识点列表
export function getKnowledgePoints() {
  return request({
    url: '/knowledge-points',
    method: 'get'
  })
}

// 更新提交状态
export function updateSubmissionStatus(homeworkId, studentId, status) {
  return request({
    url: `/student-submissions/status/${homeworkId}/${studentId}?status=${status}`,
    method: 'put'
  })
}

// 上传作业图片文件
export function uploadFile(formData) {
  return request({
    url: '/user/uploadAvatar',
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取作业批改结果
export function getHomeworkCorrectionResults(homeworkId, studentId) {
  return request({
    url: `/correct-result/homework/${homeworkId}/student/${studentId}`,
    method: 'get'
  })
}

// 获取单个题目详情
export function getQuestionDetail(questionId) {
  return request({
    url: `/questions/single/${questionId}`,
    method: 'get'
  })
}

// 添加错题
export function addWrongQuestion(data) {
  return request({
    url: '/wrong-question',
    method: 'post',
    data
  })
}

// 生成试卷
export function generateExam(data) {
  return request({
    url: '/document/generate-word',
    method: 'post',
    data,
    responseType: 'blob' // 用于处理文件下载
  })
}

// 新增：生成作业文档的API
export function generateHomeworkDocument(data) {
  return request({
    url: '/document/generate-homework',
    method: 'post',
    data
  })
}

// 批改题目
export function judgeQuestion(image, questions) {
  // 参数验证
  if (!image) {
    console.error('judgeQuestion: image参数为空');
    return Promise.reject(new Error('图片文件不能为空'));
  }

  if (!questions) {
    console.error('judgeQuestion: questions参数为空');
    return Promise.reject(new Error('题目参数不能为空'));
  }

  if (!questions.question_list || !Array.isArray(questions.question_list)) {
    console.error('judgeQuestion: questions.question_list格式错误', questions);
    return Promise.reject(new Error('题目列表格式错误'));
  }

  if (questions.question_list.length === 0) {
    console.error('judgeQuestion: questions.question_list为空数组');
    return Promise.reject(new Error('题目列表不能为空'));
  }

  const formData = new FormData()
  formData.append('image', image)
  formData.append('questions', JSON.stringify(questions))

  // 打印发送的参数
  console.log('=== judgeQuestion API调用详情 ===');
  console.log('图片文件信息:', {
    name: image.name,
    size: image.size,
    type: image.type
  });
  console.log('题目参数:', questions);
  console.log('FormData内容:', Array.from(formData.entries()).map(([key, value]) => ({
    key,
    value: key === 'image' ? `File(${value.name}, ${value.size} bytes)` : value
  })));

  return request({
    // url: 'http://123.56.176.195:8000/judge_question_db/',
    url: 'http://123.56.176.195:8000/judge_question_id/',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).catch(error => {
    console.error('=== judgeQuestion API调用失败 ===');
    console.error('错误详情:', error);
    if (error.response) {
      console.error('响应状态:', error.response.status);
      console.error('响应数据:', error.response.data);
      console.error('响应头:', error.response.headers);
    }
    throw error;
  })
}

// 保存单个批改结果
export function saveCorrectionResult(data) {
  return request({
    url: '/correct-result',
    method: 'post',
    data
  })
}

// 获取作业统计信息
export function getHomeworkStats(homeworkId) {
  return request({
    url: `/homework/stats/${homeworkId}`,
    method: 'get'
  })
}

// 更新作业批改状态和分数
export function updateCorrectionStatus({ homeworkId, studentId, status, point }) {
  return request({
    url: `/student-submissions/status/${homeworkId}/${studentId}`,
    method: 'put',
    params: { status, point }
  });
}

/**
 * 批量上传作业相关接口
 */

// 获取批量作业列表
export function getBatchHomeworkList() {
  return request({
    url: '/batch-homework/list',
    method: 'get'
  })
}

// 批量上传作业
export function uploadBatchHomework(data) {
  return request({
    url: '/batch-homework/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取批量作业详情
export function getBatchHomeworkDetail(id) {
  return request({
    url: `/batch-homework/${id}`,
    method: 'get'
  })
}

// 发布批量作业
export function publishBatchHomework(id) {
  return request({
    url: `/batch-homework/publish/${id}`,
    method: 'put'
  })
}

// 删除批量作业
export function deleteBatchHomework(id) {
  return request({
    url: `/batch-homework/${id}`,
    method: 'delete'
  })
}

/**
 * 图片作业相关接口
 */

// 获取图片作业列表
export function getImageHomeworkList() {
  return request({
    url: '/image-homework/list', // 使用图片作业接口
    method: 'get'
  })
}

// 获取图片作业详情
export function getImageHomeworkDetail(id) {
  return request({
    url: `/image-homework/${id}`,
    method: 'get'
  })
}

// 创建图片作业
export function createImageHomework(data) {
  return request({
    url: '/image-homework',
    method: 'post',
    data
  })
}

// 更新图片作业
export function updateImageHomework(id, data) {
  return request({
    url: `/image-homework/${id}`,
    method: 'put',
    data
  })
}

// 删除图片作业
export function deleteImageHomework(id) {
  return request({
    url: `/image-homework/${id}`,
    method: 'delete'
  })
}

// 发布图片作业
export function publishImageHomework(id) {
  return request({
    url: `/image-homework/${id}/publish`,
    method: 'put'
  })
}

// 发布普通作业到单个班级
export function publishHomeworkSingle(id, gradeId, data) {
  return request({
    url: `/homework/${id}/publish-single`,
    method: 'put',
    params: { gradeId },
    data
  })
}

// 批量发布普通作业到多个班级
export function publishHomeworkMultiple(id, data) {
  return request({
    url: `/homework/${id}/publish-multiple`,
    method: 'put',
    data
  })
}

// 获取作业已发布的班级ID列表
export function getHomeworkGrades(id) {
  return request({
    url: `/homework/${id}/grades`,
    method: 'get'
  })
}

// 根据作业ID获取班级和学生信息
export function getHomeworkClassesAndStudents(homeworkId) {
  return request({
    url: `/homework/${homeworkId}/classes-students`,
    method: 'get'
  })
}
